import { React, useEffect, useState } from "react";
import Chessground from "react-chessground";
import "react-chessground/dist/styles/chessground.css";
import "./MopsBoard.css";
import { useGlobalContext } from "../context";
import { IoMdRemoveCircle, IoMdAddCircle } from "react-icons/io";
import bKing from "../images/pieces/bK.svg";
import bQueen from "../images/pieces/bQ.svg";
import bRook from "../images/pieces/bR.svg";
import bBishop from "../images/pieces/bB.svg";
import bKnight from "../images/pieces/bN.svg";
import bPawn from "../images/pieces/bP.svg";
import wKing from "../images/pieces/wK.svg";
import wQueen from "../images/pieces/wQ.svg";
import wRook from "../images/pieces/wR.svg";
import wBishop from "../images/pieces/wB.svg";
import wKnight from "../images/pieces/wN.svg";
import wPawn from "../images/pieces/wP.svg";
import {
  fixBug,
  setChessboardColor,
} from "../helpers/chessboardHelperFunctions";
const Chess = require("chess.js");
let chess = new Chess();

const MopsBoard = ({ updateMessage, mopsFen, setMopsFen }) => {
  const { chessboardColor } = useGlobalContext();

  const [buttonsStyle, setButtonsStyle] = useState({ display: "none" });
  const [piecesListStyle, setPiecesListStyle] = useState({ display: "none" });

  const [square, setSquare] = useState("");

  useEffect(() => {
    chess.load(mopsFen);
    setMopsFen(chess.fen());
  }, []);

  //fix bug from chessground library
  useEffect(() => {
    fixBug();
  });

  // set chessboard color
  useEffect(() => {
    setChessboardColor(chessboardColor);
  }, [chessboardColor]);

  const coordsToSquare = (e) => {
    if (e.target.tagName == "CG-BOARD") {
      setShowPieces(false);
      const coordsHor = ["a", "b", "c", "d", "e", "f", "g", "h"];
      const coordsVert = [1, 2, 3, 4, 5, 6, 7, 8];
      const size = 400 / 8;
      const x = Math.floor(e.nativeEvent.offsetX / size);
      const y = Math.floor(e.nativeEvent.offsetY / size);
      setSquare(coordsHor[x] + coordsVert[7 - y]);
      setButtonsStyle({ transform: `translate(${x * 50}px, ${y * 50}px)` });
      if (y <= 5) {
        setPiecesListStyle({ transform: `translate(0, ${(y + 1) * 50}px)` });
      } else {
        setPiecesListStyle({ transform: `translate(0, ${(y - 2) * 50}px)` });
      }
    }
  };

  const [showPieces, setShowPieces] = useState(true);

  const addPiece = (piece) => {
    chess.load(mopsFen);
    chess.remove(square);
    setShowPieces(false);
    if (!chess.put(piece, square)) {
      updateMessage(
        "Na szachownicy może znajdować się najwyżej jeden król w danym kolorze!"
      );
    }
    setMopsFen(chess.fen());
  };

  const removePiece = () => {
    setShowPieces(false);
    chess.remove(square);
    setMopsFen(chess.fen());
  };

  const handleMove = (from, to) => {
    const piece = chess.get(from);
    chess.remove(from);
    chess.put(piece, to);
    setMopsFen(chess.fen());
  };

  return (
    <>
      <div
        className="board-section mops-board"
        onClick={(e) => coordsToSquare(e)}
      >
        <Chessground
          width={400}
          height={400}
          fen={mopsFen}
          highlight={{ lastMove: false }}
          selectable={{ enabled: false }}
          onMove={handleMove}
          animation={{ enabled: false }}
          drawable={{ enabled: false }}
          selected={""}
        />
        <div className="square-options" style={buttonsStyle}>
          <IoMdAddCircle
            className="add"
            onClick={() => setShowPieces(!showPieces)}
          />
          <IoMdRemoveCircle className="remove" onClick={() => removePiece()} />
        </div>
        {showPieces && (
          <div className="pieces-to-choose" style={piecesListStyle}>
            <div className="pieces-color">
              <img
                className="piece"
                src={bKing}
                alt=""
                onClick={() => {
                  addPiece({ type: chess.KING, color: "b" });
                }}
              />
              <img
                className="piece"
                src={bQueen}
                alt=""
                onClick={() => {
                  addPiece({ type: chess.QUEEN, color: "b" });
                }}
              />
              <img
                className="piece"
                src={bRook}
                alt=""
                onClick={() => {
                  addPiece({ type: chess.ROOK, color: "b" });
                }}
              />
              <img
                className="piece"
                src={bBishop}
                alt=""
                onClick={() => {
                  addPiece({ type: chess.BISHOP, color: "b" });
                }}
              />
              <img
                className="piece"
                src={bKnight}
                alt=""
                onClick={() => {
                  addPiece({ type: chess.KNIGHT, color: "b" });
                }}
              />
              <img
                className="piece"
                src={bPawn}
                alt=""
                onClick={() => {
                  addPiece({ type: chess.PAWN, color: "b" });
                }}
              />
            </div>
            <div className="pieces-color">
              <img
                className="piece"
                src={wKing}
                alt=""
                onClick={() => addPiece({ type: chess.KING, color: "w" })}
              />
              <img
                className="piece"
                src={wQueen}
                alt=""
                onClick={() => addPiece({ type: chess.QUEEN, color: "w" })}
              />
              <img
                className="piece"
                src={wRook}
                alt=""
                onClick={() => addPiece({ type: chess.ROOK, color: "w" })}
              />
              <img
                className="piece"
                src={wBishop}
                alt=""
                onClick={() => addPiece({ type: chess.BISHOP, color: "w" })}
              />
              <img
                className="piece"
                src={wKnight}
                alt=""
                onClick={() => addPiece({ type: chess.KNIGHT, color: "w" })}
              />
              <img
                className="piece"
                src={wPawn}
                alt=""
                onClick={() => addPiece({ type: chess.PAWN, color: "w" })}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MopsBoard;
